module.exports = __webpack_public_path__ + "img/checkrouge_off.0a6cc472.gif";